import PropTypes from 'prop-types';
import TooltipBox from './TooltipBox';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { convertSkillToTitleCase } from '../../functions/dataFormatting';
import { Stack } from '@mui/system';

function formatPercentage(value) {
    return value ? (value * 100).toFixed(0) + '%' : '';
}

/**
 * Renders a tooltip to display details about a dot on Pro drill-down.
 * It shows information such as skill, score, hit rate, and payoff.
 *
 * @component
 * @param {object} position - the position of the tooltip relative to the dot
 * @param {object} dotData - the data of the selected dot to display in the tooltip
 * @returns {JSX.Element}
 */
const DrillDownTooltip = ({ position, dotData }) => {
    const dataToDisplay = [
        { metric: 'Skill Score', value: dotData.baScore?.toFixed(1) },
        { metric: 'Hit Rate', value: formatPercentage(dotData.hitRate) },
        { metric: 'Payoff', value: formatPercentage(dotData.payoff) }
    ];

    return (
        <TooltipBox
            role='dotTooltip'
            sx={{
                top: position.y,
                left: { sm: position.x - 165, md: position.x - 185 }, // this makes it lean right.
                width: { sm: 140, md: 160 },
                padding: '1rem'
            }}
        >
            <Stack spacing={1}>
                <Stack direction={'row'} spacing={1.5} alignItems={'flex-end'}>
                    <Box
                        bgcolor={dotData.barColor}
                        sx={{
                            width: '0.5rem',
                            height: '1.3rem',
                            borderRadius: '10px'
                        }}
                    />
                    <Typography variant='body2' sx={{ fontWeight: 500 }}>
                        {convertSkillToTitleCase(dotData.skill)}
                    </Typography>
                </Stack>
                <Stack>
                    {dataToDisplay.map((item) => (
                        <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                            key={item.metric}
                        >
                            <Typography variant='body2'>
                                {item.metric}
                            </Typography>
                            <Typography variant='body2'>
                                {item.value}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        </TooltipBox>
    );
};

DrillDownTooltip.propTypes = {
    position: PropTypes.object.isRequired,
    dotData: PropTypes.object.isRequired
};
export default DrillDownTooltip;
